import * as types from '@/store/types'
import axios from 'axios'
import constConf from '../../../constconf.js'
export default {
    loadGroups: (context, botId) => {
        let mailingGroups = [
            {
                id: 0,
                title: 'Подписавшиеся',
                count: 0
            },
            {
                id: 1,
                title: 'Отписавшиеся',
                count: 0
            }
        ]
        return axios.get(constConf.client.url + '/mailinggroup/all/' + botId).then(response => {
            if (response.data.length !== 0) {
                context.commit('loadMailingGroups', mailingGroups.concat(response.data))
            } else {
                context.commit('loadMailingGroups', mailingGroups)
            }
            axios.get(constConf.client.url + '/mailinggroup/get_all_clients/' + botId).then(response => {
                if (response.data.isArray || typeof response.data === 'object') {
                    context.commit('saveCountsForBot', response.data)
                }
            }).catch((error) => {
                console.log('error get keyboards' + error)
            })
            // eslint-disable-next-line handle-callback-err
        }).catch((error) => {
            console.log('error get keyboards' + error)
        })
    },
    saveMailingGroup: (context, payload) => {
        let method = 'post'
        let url = constConf.client.url + '/mailinggroup/create'
        if (payload.id != null) {
            method = 'put'
            url = constConf.client.url + '/mailinggroup/update/' + payload.id
        }

        axios.defaults.withCredentials = true
        return axios({
            method: method,
            url: url,
            data: payload
        })
            .then((response) => {
                let functionName = { put: 'setMailingGroup', post: 'addMailingGroup' }
                context.commit(functionName[method], response.data)
                return response.data // рабочий пример возврата данных
            })
            .catch((error) => {
                console.log('ошибка при записи значения')
                console.log(error)
                return null
            })
    },
    removeMailingGroup: (context, index) => {
        let payload = context.getters.allMailingGroups[index]
        return axios({
            method: 'delete',
            url: constConf.client.url + '/mailinggroup/delete/' + payload.id
        })
            .then((response) => {
                if (response.data.hasOwnProperty('success')) {
                    context.commit('removeMailingGroup', payload.id)
                    return response
                }
                return response
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
                return { error: { text: 'Ошибка удаления' } }
            })
    },
    loadClientsByGroupId: (context, payload) => {
        axios.defaults.withCredentials = true
        axios.get(constConf.client.url + '/client/all/' + payload.bot_id + '?group_id=' + payload.groupId).then(response => {
            if ((response.data.isArray || typeof response.data === 'object')) { context.commit('loadClients', response.data) }
            // eslint-disable-next-line handle-callback-err
        }).catch((error) => {
            console.log('error get keyboards' + error)
        })
    },
    loadClientsByOptions: (context, payload) => {
        let params = ''
        for (let key in payload) {
            if (payload[key] !== '') {
                params += params === '' ? key + '=' + payload[key] : '&' + key + '=' + payload[key]
            }
        }
        axios.defaults.withCredentials = true
        return axios.get(constConf.client.url + '/client/all/' + payload.botId + '?' + params).then(response => {
            if ((response.data.isArray || typeof response.data === 'object')) {
                context.commit('loadClients', response.data)
            }
            return response.data
            // eslint-disable-next-line handle-callback-err
        }).catch((error) => {
            console.log('error load clients by options' + error)
        })
    },
    getClientsCount: (context, payload) => {
        axios.get(constConf.client.url + '/client/count/' + payload.botId + '?group_id=' + payload.group_id + '&search_text=' + payload.search_text + '&search_by=' + payload.search_by).then(response => {
            context.commit('setCountClients', response.data)
            // eslint-disable-next-line handle-callback-err
        }).catch((error) => {
            console.log('error get clients by options' + error)
        })
    },
    addClientsToMailingGroup: (context, payload) => {
        return axios.post(constConf.client.url + '/mailinggroup/addclients',
            { userIds: payload.userIds, mailingGroupId: payload.mailingGroupId }).then(response => {
            if ((response.data.isArray || typeof response.data === 'object') && response.data.hasOwnProperty('success')) { context.commit('addClientsToMailingGroup', response.data) }
            return response.data
            // eslint-disable-next-line handle-callback-err
        }).catch((error) => {
            console.log('error add clients by options' + error)
        })
    },
    removeClientsInMailingGroup: (context, payload) => {
        return axios.post(constConf.client.url + '/mailinggroup/removeclients',
            { clientIds: payload.clientIds, mailingGroupId: payload.mailingGroupId }).then(response => {
            if ((response.data.isArray || typeof response.data === 'object') && response.data.hasOwnProperty('success')) { context.commit('removeClientsInMailingGroup', response.data) }
            return response.data
            // context.commit('removeClientsInMailingGroup', payload.clientIds)
            // eslint-disable-next-line handle-callback-err
        }).catch((error) => {
            console.log('error load clients by options' + error)
        })
    },
    changeBotIdModelDefault: (context, botId) => {
        context.commit('changeBotIdModelDefault', botId)
    },
    clientUpdate: (context, model) => {
        let url = constConf.client.url + '/client/' + model.user_id
        let payload = { method: 'put', url: url, data: model }
        return context.dispatch('axios/queryWithData', payload, { root: true })
            .then(response => {
                context.commit('clientUpdate', response.response.data)
                return response
            })
    },
    getTree: (context, model) => {
        let url = constConf.client.url + '/client/get-tree/' + model.bot_id
        let payload = { method: 'get', url: url }
        return context.dispatch('axios/query', payload, { root: true })
            .then(response => {
                context.commit('getTree', response.response.data)
                return response
            })
    },
    getClient: (context, model) => {
        let url = constConf.client.url + '/client/get-client/' + model.user_id
        let payload = { method: 'get', url: url }
        return context.dispatch('axios/query', payload, { root: true })
            .then(response => {
                context.commit('getClient', response.response.data)
                return response
            })
    },
    getInvitedClients: (context, model) => {
        let url = constConf.client.url + '/client/get-invited-clients/' + model.id + '?bot_id=' + model.bot_id + '&platform=' + model.platform
        let payload = { method: 'get', url: url }
        return context.dispatch('axios/query', payload, { root: true })
            .then(response => {
                return response
            })
    },
    clientOne: (context, model) => {
        let url = constConf.client.url + '/client/one/' + model.id + '?bot_id=' + model.bot_id + '&platform=' + model.platform
        let payload = { method: 'get', url: url }
        return context.dispatch('axios/query', payload, { root: true })
            .then(response => {
                return response
            })
    },
    clientsInCardList: (context, cardListId) => {
        let url = constConf.client.url + '/client/in-card-list/' + cardListId
        let payload = { method: 'get', url: url }
        return context.dispatch('axios/query', payload, { root: true })
            .then(response => {
                if (response.ok) {
                    context.commit('loadClients', response.response.data)
                }
                return response
            })
    }
}
